import MobileMenuItem from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem'
import SideMenuNavUi from 'common/components/entities/Menu/components/Mobile/Side/ui/SideMenuNavUi'
import SideMenuUi from 'common/components/entities/Menu/components/Mobile/Side/ui/SideMenuUi'
import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { AlignSelfType } from 'common/types/styleTypes'
import { FontProps } from 'common/utils/styleUtilsNew'
import React from 'react'

export type SideMenuProps = {
  attrId: string
  menuAttrId: string
  items: MenuItemInterface[]
  alignSelf: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  sideMenuBackgroundColor?: string
  activeColor: string
  mobileActiveColor?: string
  lineHeight?: number
  mobileLineHeight?: number
  opened: boolean
  itemUnderlineColor?: string
  mobileItemUnderlineColor?: string
  forceVisible?: boolean
  spacing?: number
  subMenuSpacing?: number
  isEditing?: boolean
  disablePointerEvents?: boolean
} & FontProps

const SideMenu = ({
  attrId,
  menuAttrId,
  items,
  alignSelf,
  mobileAlignSelf,
  sideMenuBackgroundColor,
  activeColor,
  mobileActiveColor,
  opened = false,
  itemUnderlineColor,
  mobileItemUnderlineColor,
  forceVisible = false,
  fontSize,
  mobileFontSize,
  color,
  fontFamily,
  fontWeight,
  fontStyle,
  mobileColor,
  mobileFontFamily,
  mobileFontWeight,
  mobileFontStyle,
  lineHeight,
  mobileLineHeight,
  letterSpacing,
  mobileLetterSpacing,
  spacing,
  subMenuSpacing,
  isEditing,
  disablePointerEvents = false,
}: SideMenuProps) => {
  return (
    <SideMenuUi
      id={menuAttrId}
      opened={opened}
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
      forceVisible={forceVisible}
      sideMenuBackgroundColor={sideMenuBackgroundColor}
      disablePointerEvents={disablePointerEvents}
    >
      <SideMenuNavUi spacing={spacing}>
        {items.map((item, index) => (
          <MobileMenuItem
            key={`${attrId}-item-${index}-${item.link || item.text}`}
            attrId={attrId}
            item={item}
            index={index}
            activeColor={activeColor}
            mobileActiveColor={mobileActiveColor}
            mobileUnderlineColor={mobileItemUnderlineColor}
            underlineColor={itemUnderlineColor}
            fontSize={fontSize}
            mobileFontSize={mobileFontSize}
            fontFamily={fontFamily}
            fontWeight={fontWeight}
            fontStyle={fontStyle}
            mobileFontFamily={mobileFontFamily}
            mobileFontWeight={mobileFontWeight}
            mobileFontStyle={mobileFontStyle}
            lineHeight={lineHeight}
            mobileLineHeight={mobileLineHeight}
            letterSpacing={letterSpacing}
            mobileLetterSpacing={mobileLetterSpacing}
            color={color}
            mobileColor={mobileColor}
            spacing={subMenuSpacing}
            isEditing={isEditing}
          />
        ))}
      </SideMenuNavUi>
    </SideMenuUi>
  )
}

export default SideMenu
